<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Οργανόγραμμα</h4>
          <p class="card-title-desc">
            Διαχείρηση Τμημάτων και Υποτμημάτων
          </p>
          <!-- <b-tabs
            justified
            nav-class="nav-tabs-custom"
            content-class="p-3 text-muted"
          > -->
          <b-tabs content-class="p-3 text-muted">
            <b-tab active>
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="fas fa-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Αρχική</span>
              </template>

              <div class="col-xl-12">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">
                      Κατηγορίες Τμημάτων και Υποτμημάτων
                    </h4>

                    <p class="card-title-desc">
                      Προβολή όλων των τμημάτων
                    </p>
                    <div class="row">
                      <div class="col-12">
                        <div class="card">
                          <div class="card-body">
                            <div class="row mt-4">
                              <div class="col-sm-12 col-md-6"></div>
                              <!-- Search -->
                              <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                                  <label class="d-inline-flex align-items-center">
                                    Αναζήτηση:

                                    <b-form-input v-model="filter" placeholder="Αναζήτηση με όνομα τμήματος..."
                                      class="form-control form-control-sm ms-2"></b-form-input>
                                  </label>
                                </div>
                              </div>
                              <!-- Start Table -->
                              <div class="table-responsive">
                                <table class="table mb-0">
                                  <thead class="table-light">
                                    <tr>
                                      <th>Α/Α</th>
                                      <th>Ονομα Τμήματος</th>
                                      <th>Ανήκει στο:</th>
                                      <th>Πλήρης ονομασία:</th>
                                      <th v-if="is_staff">Ενέργειες</th>
                                    </tr>
                                  </thead>

                                  <tbody v-if="paginated.length > 0">
                                    <tr v-for="(department, index) in paginated" :key="index">
                                      <th scope="row">
                                        {{
                                          currentPage * perPage -
                                          perPage +
                                          index +
                                          1
                                        }}
                                      </th>
                                      <td>{{ department.name }}</td>
                                      <td v-if="department.parent_name">
                                        {{ department.parent_name }}
                                      </td>
                                      <td v-else>-</td>
                                      <td>{{ department.full_path_name }}</td>
                                      <td v-if="
                                        is_staff &&
                                        department.name != 'Χωρίς Τμήμα'
                                      ">
                                        <i class="mdi mdi-pencil" @click.prevent="
                                          $bvModal.show(department.name)
                                          "></i>
                                        <!-- Start Modal -->
                                        <b-modal :id="department.name" title="Επεξεργασία Τμήματος" centered hide-footer
                                          @hidden="resetModal">
                                          <div class="col-lg-12">
                                            <div class="card">
                                              <div class="card-body">
                                                <h4 class="card-title">
                                                  Επεξεργασία:
                                                  {{
                                                    department.full_path_name
                                                  }}
                                                </h4>
                                                <b-alert v-if="
                                                  modalAlert &&
                                                  modalAlert.alertMsg
                                                " show dismissible :variant="modalAlert.alertVariant
                                                  ">{{
                                                    modalAlert.alertMsg
                                                  }}</b-alert>
                                                <p class="card-title-desc">
                                                  Επεξεργασία Τμήματος:
                                                  {{ department.name }}.<br />
                                                  Μπορείτε να μετακινήσετε το
                                                  τμήμα σε αλλο τμήμα ή και να
                                                  διορθώσετε την ονομασία
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <form class="form-horizontal" role="form" @submit.prevent="
                                            modalFormUpdateDepartment
                                          ">
                                            <b-form-group class="mb-3" id="example text" label-cols-lg="2" label="Ονομα"
                                              label-for="text">
                                              <b-form-input required for="text" placeholder="Όνομα Τμήματος"
                                                :value="department.name" @change="changedName"
                                                ref="modalDepartmentName"></b-form-input>
                                              <b-form-input hidden :id="department.id.toString()"
                                                ref="modalChangeDepartmentId"></b-form-input>
                                            </b-form-group>
                                            <div class="mb-3 row">
                                              <label class="col-md-2 col-form-label">Τμήμα
                                              </label>
                                              <div class="col-md-10">
                                                <select class="form-control" ref="modalDepartmentId">
                                                  <option :value="department.parent">{{
                                                    department.full_parent_name
                                                  }}</option>
                                                  <option :value="department.id" v-for="department in departmentList"
                                                    :key="department.id">{{
                                                      department.full_path_name
                                                    }}</option>
                                                </select>
                                              </div>
                                            </div>
                                            <button class="btn btn-primary" type="submit">
                                              Ολοκλήρωση
                                            </button>
                                          </form>
                                        </b-modal>
                                        <!-- End of modal -->
                                        <i class="mdi mdi-trash-can" @click.prevent="confirm(department)"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tbody v-else>
                                    <h4>Δεν υπάρχουν Τμήματα</h4>
                                  </tbody>
                                </table>
                              </div>
                              <!-- End of Table -->
                            </div>
                          </div>
                        </div>
                        <!-- Pagination -->
                        <div class="col-lg-12">
                          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                            aria-controls="my-table" align="center" @input="pageClick(currentPage)"></b-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab v-if="is_staff">
              <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                  <i class="bx bx-add-to-queue"></i>
                </span>
                <span class="d-none d-sm-inline-block">Προσθήκη Τμήματος</span>
              </template>
              <div class="card-body">
                <h4 class="card-title">
                  Κατηγορίες Τμημάτων και Υποτμημάτων
                </h4>
                <p class="card-title-desc">
                  Προσθήκη Τμήματος
                </p>

                <hr />
                <b-alert v-if="alert && alert.alertMsg" show dismissible :variant="alert.alertVariant">{{ alert.alertMsg
                }}</b-alert>

                <form class="form-horizontal" role="form" @submit.prevent="formAddDepartment">
                  <b-form-group class="mb-3" id="example text" label-cols-lg="2" label="Ονομα" label-for="text">
                    <b-form-input required for="text" placeholder="Όνομα Τμήματος"
                      v-model="departmentName"></b-form-input>
                  </b-form-group>
                  <div class="mb-3 row">
                    <label class="col-md-2 col-form-label">Τμήμα</label>
                    <div class="col-md-10">
                      <select class="form-control" v-model="selectedDepartment">
                        <option :value="department.id" v-for="department in departmentList" :key="department.id">{{
                          department.full_path_name }}</option>
                      </select>
                    </div>
                  </div>
                  <button class="btn btn-primary" type="submit">
                    Προσθήκη
                  </button>
                </form>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        <div v-if="voBasicDepartmentsTree && voBasicDepartmentsTree[0]">
          <vo-basic :data="voBasicDepartmentsTree[0]" :pan="true" :zoom="true" :toggleCollapse="false"></vo-basic>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../api/session";
import Swal from "sweetalert2";
import { VoBasic } from "vue-orgchart";
// import { VoEdit } from "vue-orgchart";
import "vue-orgchart/dist/style.min.css";
import { mapGetters, mapState } from "vuex";
import { eventCreate } from "../../../eventspy.js";

export default {
  page: {
    title: "Οργανόγραμμα",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VoBasic },
  data() {
    return {
      title: "Οργανογραμμα",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Οργανόγραμμα",
          active: true,
        },
      ],
      departmentList: [],
      voBasicDepartmentsTree: [],
      selectedDepartment: "",
      departmentName: "",
      alert: {
        alertMsg: "",
        alertVariant: "",
      },
      modalAlert: {
        alertMsg: "",
        alertVariant: "",
      },
      currentPage: 1,
      perPage: 10,
      filter: "",
    };
  },

  async mounted() {
    await this.fetchAllDepartments();
    this.voBasicStyle();
  },

  computed: {
    ...mapGetters("auth", ["userLoggedIn", "is_staff"]),
    ...mapState("utils", ["departments", "voBasicDepartments"]),
    // departmentList() {
    //   return this.departments;
    // },
    voBasicDeps() {
      return this.voBasicDepartments.length > 0
        ? this.voBasicDepartments
        : this.departments;
    },

    indexStart() {
      return (this.currentPage - 1) * this.perPage;
    },
    indexEnd() {
      return this.indexStart + this.perPage;
    },
    totalRows() {
      const total = this.departmentList.filter((e) => {
        {
          return e.name.toLowerCase().includes(this.filter.toLowerCase());
        }
      });
      return total.length;
    },
    paginated() {
      if (!this.filter) {
        return this.departmentList.slice(this.indexStart, this.indexEnd);
      } else {
        const results = this.departmentList.filter((e) => {
          {
            return e.name.toLowerCase().includes(this.filter.toLowerCase());
          }
        });
        return results.slice(this.indexStart, this.indexEnd);
      }
    },
  },
  methods: {
    pageClick(current) {
      this.currentPage = current;
    },
    confirm(department) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          this.deleteDepartment(department);
          Swal.fire("Διαγράφηκε!", "Το τμήμα σας έχει διαγραφεί.", "success");
        }
      });
    },
    async deleteDepartment(department) {
      eventCreate(`Διαγραφή Τμηματος ${department.name}`, 3);
      await session
        .delete(`api/departments/${department.id}/delete/`)
        .then(() => {
          this.voBasicDepartmentsTree = "";
          this.fetchAllDepartments();
          this.$store.dispatch("utils/fetchDepartments");
          this.$store.dispatch("utils/fetchDepartmentOptions");
        })
        .catch((e) => {
          console.log(e.response.data);
        });
    },
    voBasicStyle() {
      if (this.$el.querySelector(".orgchart")) {
        this.$el
          .querySelector(".orgchart")
          .setAttribute("style", "height:50vh;");
        this.$el
          .querySelector(".vo-basic")
          .setAttribute("style", "border-style:double;");
      }
    },
    async fetchAllDepartments() {
      await session
        .get("api/departments/")
        .then((resp) => {
          this.departmentList = resp.data;
          this.voBasicDepartmentsTree = resp.data;
        })
        .catch((e) => {
          console.log(e.response.data);
        });
      // this.fetchDepartments();
      // this.departmentList = this.departments();

      this.voBasicStyle();
    },
    async formAddDepartment() {
      await session
        .post("api/departments/add/", {
          name: this.departmentName,
          parent: this.selectedDepartment,
        })
        .then(() => {
          this.alert.alertMsg = "Το τμήμα προστέθηκε επιτυχώς!";
          this.alert.alertVariant = "success";
          this.voBasicDepartmentsTree = "";
          this.fetchAllDepartments();

          eventCreate(`Προσθηκη Τμηματος ${this.departmentName}`, 1);
          this.$store.dispatch("utils/fetchDepartments");
          // this.$store.dispatch("utils/fetchPeopleOptionFields");
          this.$store.dispatch("utils/fetchDepartmentOptions");
        })
        .catch((e) => {
          console.log(e);
          if (e.response.data) {
            const keys = Object.keys(e.response.data);
            let ErrorMessageText = "";
            keys.forEach((key) => {
              ErrorMessageText += `${e.response.data[key]}`;
            });
            this.alert.alertMsg = `Υπήρξε πρόβλημα στην διαδικασία προσθήκης τμήματος: ${ErrorMessageText}`;
            this.alert.alertVariant = "danger";
            return;
          }
          this.alert.alertMsg = `Υπήρξε πρόβλημα στην διαδικασία προσθήκης τμήματος:`;
          this.alert.alertVariant = "danger";
        });
      setTimeout(() => {
        this.alert.alertMsg = "";
        this.alert.alertVariant = "";
      }, 3000);
    },
    changedName(val) {
      this.departmentName = val;
    },
    async modalFormUpdateDepartment() {
      let modalDepartmentName = this.$refs["modalDepartmentName"][0].value;
      const modalDepartmentId = this.$refs["modalDepartmentId"][0].value;
      const modalChangeDepartmentId =
        this.$refs["modalChangeDepartmentId"][0].id;
      if (this.departmentName) {
        modalDepartmentName = this.departmentName;
      }
      this.departmentName = "";

      await session
        .put(`api/departments/${modalChangeDepartmentId}/update/`, {
          name: modalDepartmentName,
          parent: modalDepartmentId,
        })
        .then(() => {
          this.voBasicDepartmentsTree = "";
          this.fetchAllDepartments();
          eventCreate(
            `Επεξεργασία Τμηματος ${this.departmentName} σε ${modalDepartmentName}`,
            2
          );
          this.modalAlert.alertMsg = "Το τμήμα ανανεώθηκε επιτυχώς!";
          this.modalAlert.alertVariant = "success";

          this.$store.dispatch("utils/fetchDepartments");
          // this.$store.dispatch("utils/fetchPeopleOptionFields");
          this.$store.dispatch("utils/fetchDepartmentOptions");

          // this.$bvModal(modalDepartmentName).hide();
        })
        .catch((e) => {
          this.modalAlert.alertMsg =
            "Υπήρξε πρόβλημα στην διαδικασία ενημέρωσης τμήματος";
          this.modalAlert.alertVariant = "danger";
          console.log(e.response.data);
        });
      setTimeout(() => {
        this.modalAlert.alertMsg = "";
        this.modalAlert.alertVariant = "";
        this.$bvModal.hide(modalDepartmentName);
      }, 3000);

      this.$forceUpdate();
    },
    resetModal() {
      this.modalAlert.alertMsg = "";
      this.modalAlert.alertVariant = "";
    },
  },
};
</script>

<style scoped>
.mdi-pencil {
  padding: 10px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
}

.mdi-trash-can {
  color: red;
  padding: 10px;
  transition: all 0.6s;
}

.mdi-pencil {
  color: rgb(224, 151, 15);
  cursor: pointer;
  font-size: 20px;
}

.mdi-trash-can {
  color: red;
  cursor: pointer;
  font-size: 20px;
}
</style>
